export function extractThreadId(message, fallback) {
  const candidates = [];
  const push = (v) => {
    if (typeof v !== "string") return;
    const s = v.trim();
    if (!s) return;
    candidates.push(s);
  };

  push(message?.thread_id);
  push(message?.thread);
  push(message?.metadata?.thread);
  push(message?.receiver);

  if (typeof fallback === "string") {
    push(fallback);
  } else if (fallback && typeof fallback === "object") {
    push(fallback.thread_id);
    push(fallback.thread);
    push(fallback.threadId);
    push(fallback.conversationId);
    push(fallback.receiver);
    push(fallback.id);
  }

  let thread = candidates[0] || null;
  if (!thread) return null;
  if (thread.startsWith("thread#")) thread = thread.slice("thread#".length);
  return thread || null;
}

export function normalizeTimestamp(value) {
  if (!value || typeof value !== "string") return value;

  const match = value.match(
    /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})(?:\.(\d{1,9}))?$/
  );
  if (!match) return value;

  const ms = ((match[3] || "") + "000").slice(0, 3);
  return `${match[1]}T${match[2]}.${ms}Z`;
}
